// authApi.ts
 import { ICredentials ,INetworkResponse} from "../../interfaces";


 import { api } from "../api";

const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ login, password, stationId, centerId }: ICredentials) => ({
        url: "/auth/login",
        method: "POST",
        body: { login, password, centerId, stationId },
      }),
      transformResponse: (response: INetworkResponse<any>) => response,
    }),
    logout: builder.mutation({
      query: ({ refreshToken }) => ({
        url: "/auth/SignOut",
        method: "POST",
        body: { refreshToken },
      }),
    }),
    refreshToken: builder.mutation({
      query: ({ refreshToken }: { refreshToken: string }) => ({
        url: "/auth/refreshToken",
        method: "POST",
        body: { refreshToken },
      }),
    }),
    getUser: builder.query({
      query: ({ userId, doctorId }) => ({
        url: `/user/${userId}?include={"credential":{"include":{"credentialSecrets":true}} ${doctorId ? ',"doctor": "true" ' : ""} }`,
        method: "GET",
      }),
    }),
    updateUser: builder.mutation({
      query: ({ id, body }) => ({
        url: `/user/${id}`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRefreshTokenMutation,
  useLogoutMutation,
  useGetUserQuery,
  useUpdateUserMutation,
} = authApi;

export default authApi;
